import { omit } from 'lodash-es'
import { types } from 'mobx-state-tree'

import { ReferenceFreightieOrUser } from '../Actors'
import { TAvatarType } from '../avatars/AvatarType'
import { getAvatar, getAvatarType, getTitleFromActor } from '../avatars/avatarUtils'
import { IActivityMessageSection, IActivityTitle, TEXT } from '../messages/MessageSectionType'
import { Activity } from './Activity'

export const MessageActivity = types
  .compose(
    'MessageActivity',
    Activity,
    types.model({
      actor: ReferenceFreightieOrUser,
      content: types.string,
      actorType: types.string, // 'user' | 'freightie'
    })
  )
  .preProcessSnapshot((snapshot) => {
    const { freightieAuthor_id, userAuthor_id } = snapshot
    return {
      ...snapshot,
      actor: freightieAuthor_id || userAuthor_id,
      actorType: freightieAuthor_id ? 'freightie' : 'user',
    }
  })
  .actions(() => ({
    postProcessSnapshot(snapshot) {
      const pureActivity = omit(snapshot, 'actor')
      return {
        ...pureActivity,
        freightieAuthor_id: snapshot.actorType === 'freightie' ? snapshot.actor : null,
        userAuthor_id: snapshot.actorType === 'user' ? snapshot.actor : null,
      }
    },
  }))
  .views((self) => ({
    get avatarType(): TAvatarType {
      return getAvatarType(self.actor)
    },
    get avatar(): string {
      return getAvatar(self.actor)
    },
    get messageContent(): IActivityMessageSection[] {
      return [
        {
          type: TEXT,
          content: self.content,
        },
      ]
    },
    get title(): IActivityTitle {
      return getTitleFromActor(self.actor)
    },
  }))

export type TMessageActivity = typeof MessageActivity.Type
